import {
  EquipmentPlannedDto,
  EquipmentType,
  StoppageReasonResponseDto,
  StoppageResponseDto,
  StoppageResponseReasonDto,
  StoppageResponseEquipmentDto,
} from '@operations/app/api'
import { StoppageFormData } from '@operations/stores/StoppageStore'

export const mapStoppageReasonToResponseDto = (
  stoppageReason: StoppageResponseReasonDto,
): StoppageReasonResponseDto => {
  return {
    id: stoppageReason.id,
    name: stoppageReason.name,
    shortName: stoppageReason.name,
    type: stoppageReason.type,
    responsible: stoppageReason.responsible,
  }
}

export const mapStoppageReasonResponseDtoToStoppageInnerDto = (
  stoppageReason: StoppageReasonResponseDto,
): StoppageResponseReasonDto => {
  return {
    id: stoppageReason.id,
    name: stoppageReason.name,
    type: stoppageReason.type,
    responsible: stoppageReason.responsible,
  }
}

export const mapStoppageEquipmentToEquipmentPlannedDto = (
  equipment: StoppageResponseEquipmentDto,
): EquipmentPlannedDto => {
  return {
    id: equipment.id,
    name: equipment.name,
    equipmentType: EquipmentType.Sts,
  }
}

export const mapStoppageToFormData = (
  vesselVisitId: number,
  stoppage?: StoppageResponseDto,
): StoppageFormData => {
  return {
    id: stoppage?.id ?? undefined,
    stoppageReasonId: stoppage?.stoppageReason.id ?? undefined,
    carrierVisitId: vesselVisitId,
    fromDate: stoppage?.from ?? undefined,
    fromTime: stoppage?.from ?? undefined,
    toDate: stoppage?.to ?? undefined,
    toTime: stoppage?.to ?? undefined,
    equipmentIds: stoppage?.equipments.map(e => e.id) ?? [],
    notes: stoppage?.notes ?? undefined,
  }
}
